import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-return-url-redirect',
  template: '',
})
export class ReturnUrlRedirectComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        if (params.returnUrl && params.returnUrl.startsWith('/')) {
          this.router.navigateByUrl(params.returnUrl);
        } else {
          this.router.navigateByUrl('/');
        }
      }
      );
  }
}
